<template>
  <div class="link-paginator">
    <template v-for="(page, index) in pages">
      <PaginationLink
        v-if="displayPage(page)"
        :key="index"
        :active="page === currentPage"
        :emit-only-click="emitOnlyClick"
        :page="page"
        :url="url(page)"
        :aria-label-prefix="ariaLabelPrefix"
        :current-page-aria-label="currentPageAriaLabel"
        @click="emitClick"
      />
      <span
        v-else-if="displayEllipsis(page)"
        :key="index"
        class="link-paginator__ellipsis"
      >
        …
      </span>
    </template>
  </div>
</template>

<script>
import PaginationLink from '~/components/pagination-link.vue';
import Paginator from '~/mixins/paginator';

export default {
  name: 'LinkPaginator',
  components: {
    PaginationLink,
  },
  mixins: [Paginator],
  props: {
    ariaLabelPrefix: {
      type: String,
      default: '',
    },
    currentPageAriaLabel: {
      type: String,
      default: '',
    },
  },
  emits: ['click'],
  methods: {
    displayPage(page) {
      if (page === 1 || page === this.totalPages) return true;
      return (
        page === this.currentPage || page === this.currentPage - 1 || page === this.currentPage + 1
      );
    },
    displayEllipsis(page) {
      if (page !== 2 && page !== this.totalPages - 1) return false;
      return !this.displayPage(page);
    },
    emitClick(target) {
      this.$emit('click', target);
    },
  },
};
</script>

<style lang="scss">
@use 'assets/base' as *;

.link-paginator {
  display: flex;
  align-items: center;
  grid-gap: $grid-base * 2;
}
</style>
